/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Column } from "components/styles";
import { HeaderDate } from "./styles";
//#endregion
//#region Components
import Header from "./components/Header/Header";
import SchedulesWrapper from "../SchedulesWrapper/SchedulesWrapper";
//#endregion
//#region Images
//#endregion
//#region Utils
import {
    DAY_IN_MILLIS,
    WEEK_DAYS,
    getWeekDateRange,
    getTodayWithoutHourInMillis,
    getQuantityWeeksInMonth,
    getCurrentWeekInMonth,
    getFirstDateOfWeekByMonth,
    getFirstDateOfBeforeWeekByMonth,
    getLastDateOfWeekByMonth
} from "components/CustomDatePicker/utils/helpers";
//#endregion

const SchedulesByAdviser = ({
    dateFiltered,
    setTriggerRequest,
    isAdviser,
    dataFetch: {
        advisers, schedulesWeekByAdviser
    },
    filterFields,
    dataPaginator,
    changeFilterField,
    reloadData,
    nextOrBackReservationPage,
    isBoss
}) => {
    const { setCurrentPage } = dataPaginator;
    //#region States
    const [quantityPages, setQuantityPages] = useState(0);
    const [schedulesData, setSchedulesData] = useState({
        headers: [],
        body: []
    });
    //#endregion
    //#region Effects
    const hasAppointmentsOnDate = (column, date) => {
        return (column?.appointments || []).some(({ schedule }) => schedule?.date === date);
    };
    const fillSchedulesCoordinator = () => {
        // Obteniendo lista de fechas
        const dateList = getDateList();
        const data = {
            headers: dateList.map(dateItem => {
                if (!dateItem)
                    return {
                        render: (
                            <HeaderDate className="main-content">
                                <span></span>
                            </HeaderDate>
                        )
                    };
                const { today, str } = dateItem;
                const [day, dateNumber] = str.split(" ");
                const classList = ["main-content"];
                today && classList.push("today");
                return {
                    render: (
                        <HeaderDate title={str} className={classList.join(" ")}>
                            <span>{day}</span>
                            <div>
                                <span>{dateNumber}</span>
                            </div>
                        </HeaderDate>
                    )
                };
            }),
            body: dateList.map(dateItem => {
                if (!dateItem)
                    return null;
                const { date } = dateItem;
                const column = schedulesWeekByAdviser.find(item => hasAppointmentsOnDate(item, date));
                if (!column)
                    return null;
                return { ...column };
            })
        };
        setSchedulesData(data);
    }
    const fillSchedulesAdviser = () => {
        // Obteniendo total de reservas actuales
        const totalReservations = schedulesWeekByAdviser
            .reduce((sum1, { appointments }) => {
                return sum1 + appointments.reduce((sum2, { reservations }) => {
                    return sum2 + reservations.length;
                }, 0);
            }, 0);
        // Obteniendo lista de fechas
        const dateList = getDateList();
        const filteringByStudent = filterFields.student.field.length > 0;
        let data = {
            headers: dateList.map(dateItem => {
                if (!dateItem)
                    return {
                        render: (
                            <HeaderDate className="main-content">
                                <span></span>
                            </HeaderDate>
                        )
                    };
                const { today, str } = dateItem;
                const [day, dateNumber] = str.split(" ");
                const classList = ["main-content"];
                today && classList.push("today");
                return {
                    render: (
                        <HeaderDate title={str} className={classList.join(" ")}>
                            <span>{day}</span>
                            <div>
                                <span>{dateNumber}</span>
                            </div>
                        </HeaderDate>
                    )
                };
            }),
            body: dateList.map(dateItem => {
                if (!dateItem)
                    return null;
                const { date } = dateItem;
                const appointments = schedulesWeekByAdviser
                    .filter(item => {
                        return hasAppointmentsOnDate(item, date);
                    })
                    .reduce((acc, { appointments }) => {
                        return [...acc, ...appointments];
                    }, []);
                if (appointments.length === 0)
                    return null;
                return {
                    appointments,
                    filteringByStudent
                };
            })
        };
        if (filteringByStudent)
            data = fillDisablementInSchedulesData(data, totalReservations);
        setSchedulesData(data);
    }
    function fillSchedules() {
        isAdviser ?
            fillSchedulesAdviser() :
            fillSchedulesCoordinator();
    }
    useEffect(() => {
        fillSchedules();
    }, [schedulesWeekByAdviser]);
    useEffect(() => {
        setQuantityPages(getQuantityWeeksInMonth(filterFields.date));
        setCurrentPage(getCurrentWeekInMonth(filterFields.date));
    }, [filterFields.date]);
    //#endregion
    //#region Functions
    const fillDisablementInSchedulesData = (data, totalReservations) => {
        const thereIsMoreThan1 = totalReservations > 1;
        let quantityFoundReservation = 0;
        return {
            ...data,
            body: data.body
                .reduce((acc, column) => {
                    if (!column)
                        return [
                            ...acc,
                            null
                        ];
                    return [
                        ...acc,
                        {
                            ...column,
                            appointments: column.appointments.map((appointment) => {
                                return {
                                    ...appointment,
                                    reservations: appointment.reservations.map(reservation => {
                                        quantityFoundReservation++;
                                        return {
                                            ...reservation,
                                            quantity: {
                                                ...reservation.quantity,
                                                thereIsMoreThan1,
                                                position: (
                                                    quantityFoundReservation === 1
                                                        ? "first"
                                                        : quantityFoundReservation === totalReservations
                                                            ? "last" : "middle"
                                                )
                                            }
                                        };
                                    })
                                };
                            })
                        }
                    ];
                }, [])
        };
    }
    const getDateList = () => {
        // Obteniendo inicio de semana
        const currentFilterDate = filterFields.date === -1 ? Date.now() : filterFields.date;
        const filterDateObj = new Date(currentFilterDate);
        const [startWeekDate] = getWeekDateRange(filterDateObj);
        const startWeekDateMillis = startWeekDate.getTime();
        const today = getTodayWithoutHourInMillis();
        // Obteniendo lista de fechas
        const dateList = Array(7).fill().map((_, days) => {
            const dateMillis = startWeekDateMillis + DAY_IN_MILLIS * days;
            const dateObj = new Date(dateMillis);
            if (filterDateObj.getMonth() !== dateObj.getMonth())
                return null;
            return {
                date: dateMillis,
                today: dateMillis === today,
                str: `${WEEK_DAYS[dateObj.getDay()].substring(0, 3)} ${dateObj.getDate()}`
            };
        });
        return dateList;
    }
    const changePageBasedOnFilterDate = (next = true) => {
        try {
            let { date } = filterFields;
            if (next) {
                const lastDateOfWeekByMonth = getLastDateOfWeekByMonth(date);
                changeFilterField("date", lastDateOfWeekByMonth + DAY_IN_MILLIS);
                return;
            }
            const firstDateOfWeekByMonth = getFirstDateOfWeekByMonth(date);
            const firstDateAWeekBeforeByMonth = getFirstDateOfBeforeWeekByMonth(firstDateOfWeekByMonth);
            changeFilterField("date", firstDateAWeekBeforeByMonth);
        }
        finally {
            setTriggerRequest(true);
        }
    }
    //#endregion
    return (
        <Column width="100%" marginTop="35px">
            <Header advisers={advisers}
                isCoordinator={!isAdviser}
                filterFields={filterFields}
                dataPaginator={{
                    ...dataPaginator,
                    quantityPages,
                    nextPage: () => changePageBasedOnFilterDate(),
                    backPage: () => changePageBasedOnFilterDate(false)
                }} />
            <SchedulesWrapper
                dateFiltered={dateFiltered}
                reloadData={reloadData}
                data={schedulesData}
                date={filterFields.date}
                isAdviser={isAdviser}
                nextOrBackReservationPage={nextOrBackReservationPage}
                takeWeek
                isBoss={isBoss} />
        </Column>
    );
}

export default SchedulesByAdviser;
